import { api } from './api';

export interface OrderConfig {
  courierId: number;
  serviceId: number;
  planId: number;
}

export interface BulkUploadHistoryItem {
  id: number;
  fileName: string;
  totalOrders: number;
  successfulOrders: number;
  errorOrders: number;
  status: number; // 0 = processing, 1 = successful, 2 = unsuccessful, 3 = partial
  createdAt: string;
}

export const bulkService = {
  /**
   * Upload the original untouched bulk file along with the global warehouse and order configs
   */
  async uploadProcessedBulkFile(
    file: File,
    warehouse: any,
    configs: Record<string, OrderConfig>
  ): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('warehouse', JSON.stringify(warehouse));
    formData.append('configs', JSON.stringify(configs));

    const { data } = await api.post('/bulk/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },

  /**
   * Fetch bulk upload file logs from the last 30 days
   */
  async getBulkUploadHistory(): Promise<BulkUploadHistoryItem[]> {
    const { data } = await api.get<BulkUploadHistoryItem[]>('/bulk/list');
    return data;
  },

  /**
   * Download the processed bulk output file with statuses
   */
  async downloadProcessedBulkFile(fileId: number): Promise<any> {
    return await api.get(`/bulk/download/${fileId}`, {
      responseType: 'blob'
    });
  },
};
